import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ActionItemModel, ActionMode } from './types';

@Component({
  selector: 'app-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ActionsComponent {
  @Input() mode?: ActionMode = 'icons';
  @Input() items?: Array<ActionItemModel>;
  @Input() object?: any;
  @Output() clicked = new EventEmitter<void>();
}
